
import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export function useLiveDemo() {
  const location = useLocation();
  const { user } = useAuth();

  // Compute synchronously so the value is correct on the very first render.
  // The previous useState + useEffect approach caused isLiveDemo to start as
  // `false` and flip to `true` after the first paint, which triggered every
  // downstream hook (Firestore listeners, API calls, etc.) to fire twice —
  // effectively doubling all network requests on the live-demo pages.
  const isLiveDemo = useMemo(
    () => !user && location.pathname.startsWith("/live-demo"),
    [user, location.pathname],
  );

  return isLiveDemo;
}